import React from 'react';
import { observer } from 'mobx-react';

export const Repeater: React.FC<{ errors: string[] | undefined, child: (error: string) => 
    React.ReactNode, viewId: string | undefined, }> = observer(({errors, child, viewId}) => 
    (errors
        ? <div id={viewId+'-invalid'}>{errors.map(error => child(error))}</div>
        : null)
);